import { render, staticRenderFns } from "./ProjectValuationExternalReportPage5.vue?vue&type=template&id=04a01874&"
import script from "./ProjectValuationExternalReportPage5.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports